import React from "react";
import { useTranslation } from "react-i18next";
import SalepageOrderList from "./SalepageOrderList";

export default function SalepageOrder() {
  const { t } = useTranslation();

	return (
		<div className="p-4">
			<p>{t("salepage_order_title")}</p>
			<SalepageOrderList />
		</div>
	);
}
